/*
  Ayni Ppacha V4 – Bildergalerie in Produktkarten (snippets/ayni-v4-card.liquid, Parameter gallery)
  - Bild 1 lädt normal (lazy/eager laut Snippet), Bild 2–n haben kein src.
  - Bild 2 wird bei Interaktionsabsicht geladen (Hover, Touch, Fokus), danach immer aktuelles + nächstes Bild.
  - Komplett delegiert → funktioniert auch nach AJAX-Filtern und „Weitere anzeigen“.
*/
(function () {
  if (window.__apCardGallery) return;
  window.__apCardGallery = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(slide) {
    var img = slide && slide.querySelector('img[data-src]');
    if (!img) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function trackOf(gallery) {
    return gallery && gallery.querySelector('[data-ap-gallery-track]');
  }

  function indexOf(track) {
    return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }

  function sync(gallery, forced) {
    var track = trackOf(gallery);
    if (!track) return;
    var slides = track.children;
    var i = typeof forced === 'number' ? forced : indexOf(track);
    i = Math.max(0, Math.min(i, slides.length - 1));
    load(slides[i]);
    load(slides[i + 1]);
    var prev = gallery.querySelector('[data-ap-gallery-prev]');
    var next = gallery.querySelector('[data-ap-gallery-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= slides.length - 1;
  }

  // Interaktionsabsicht → Bild 2 vorladen
  function prime(e) {
    var gallery = e.target && e.target.closest && e.target.closest('[data-ap-gallery]');
    if (!gallery || gallery.__apPrimed) return;
    gallery.__apPrimed = true;
    var track = trackOf(gallery);
    if (track) load(track.children[1]);
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, prime, { passive: true, capture: true });
  });

  // Wischen / Trackpad: scroll-Events der Tracks (Capture, da scroll nicht bubbelt)
  var queued = [];
  var frame = 0;
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-ap-gallery-track]')) return;
    if (queued.indexOf(track) === -1) queued.push(track);
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      queued.splice(0).forEach(function (t) { sync(t.closest('[data-ap-gallery]')); });
    });
  }, { passive: true, capture: true });

  // Pfeile (Desktop)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ap-gallery-prev], [data-ap-gallery-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var gallery = btn.closest('[data-ap-gallery]');
    var track = trackOf(gallery);
    if (!track) return;
    var dir = btn.hasAttribute('data-ap-gallery-next') ? 1 : -1;
    var target = Math.max(0, Math.min(indexOf(track) + dir, track.children.length - 1));
    sync(gallery, target); // Pfeile sofort, nicht erst nach dem Scroll-Event
    track.scrollTo({ left: target * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();